import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  pushToDataLayer(eventData: any): void {
    if (this.isBrowser) {
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push(eventData);
     
    }
  }
}